import { render, staticRenderFns } from "./OfficerOpenRecruitmentManagerList.vue?vue&type=template&id=766fabed&scoped=true&"
import script from "./OfficerOpenRecruitmentManagerList.vue?vue&type=script&lang=js&"
export * from "./OfficerOpenRecruitmentManagerList.vue?vue&type=script&lang=js&"
import style0 from "./OfficerOpenRecruitmentManagerList.vue?vue&type=style&index=0&id=766fabed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766fabed",
  null
  
)

export default component.exports